// Tracks which opportunities currently have unsaved local edits, so the
// background poll in Main can skip them and never overwrite an opportunity the
// user is actively editing (which would make just-added sections/fields vanish).
//
// A module-level singleton is intentional: it's a cross-cutting registry shared
// between the editor (which knows `dirty`) and the poll (which must respect it)
// without threading a callback through every intermediate component.

const dirtyOpportunityIds = new Set();

export function markOpportunityDirty(id) {
    if (id) dirtyOpportunityIds.add(id);
}

export function markOpportunityClean(id) {
    if (id) dirtyOpportunityIds.delete(id);
}

export function isOpportunityDirty(id) {
    return dirtyOpportunityIds.has(id);
}
